import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClassFromExist } from 'class-transformer';
import { GetTakeLeavesInput, Result, ResultList, SingleResult, TakeLeaveInput, TakeLeaveResult } from '../models';
import { Utility } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class TakeLeaveService {

  constructor(private httpClient: HttpClient) { }

  public addTakeLeave(takeLeaveInput: TakeLeaveInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'TakeLeave/AddTakeLeave', takeLeaveInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editTakeLeave(id: number, takeLeaveInput: TakeLeaveInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'TakeLeave/EditTakeLeave?id=' + id, takeLeaveInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public confirmOrRejectTakeLeave(id: number, isAccepted: boolean): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'TakeLeave/ConfirmOrRejectTakeLeave?id=' + id, isAccepted, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteTakeLeave(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'TakeLeave/DeleteTakeLeave?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getTakeLeave(id: number): Promise<SingleResult<TakeLeaveResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'TakeLeave/GetTakeLeave?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<TakeLeaveResult>(TakeLeaveResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<TakeLeaveResult>(TakeLeaveResult), result.error));
  }

  public getTakeLeaves(getTakeLeavesInput: GetTakeLeavesInput): Promise<ResultList<TakeLeaveResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'TakeLeave/GetTakeLeaves', getTakeLeavesInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TakeLeaveResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TakeLeaveResult>(), result.error));
  }
}
